<section class="page-container">
  <div class="flex items-center justify-between">
    <h1 class="main-heading">COE allocation</h1>
    <app-navpath />
  </div>
  <ul class="tabs-container">
    <li
      (click)="selectedTab = 'single'"
      [ngClass]="
        selectedTab == 'single' ? 'tab-item_selected' : 'tab-item'
      "
    >
      Single allocation
    </li>
    <li
      (click)="selectedTab = 'all'"
      [ngClass]="
        selectedTab == 'all' ? 'tab-item_selected' : 'tab-item'
      "
    >
      Allocate all
    </li>
  </ul>
  <div
    [hidden]="!(selectedTab == 'single')"
    class="content-container__tabs"
  >
    <form class="flex text-sm">
      <label>
        <input
          type="radio"
          name="bidType"
          value="C"
          [(ngModel)]="BidType"
        />
        Customer's bid
      </label>
      <label>
        <input
          type="radio"
          name="bidType"
          value="K"
          [(ngModel)]="BidType"
        />
        Komoco's bid
      </label>
      <label>
        <input
          type="radio"
          name="bidType"
          value="P"
          [(ngModel)]="BidType"
        />
        Others
      </label>
    </form>
    <section class="content-container">
      <h2 class="sub-heading w-full border-b">Details of contract</h2>
      <app-data-form
        [dataFields]="detailsContract"
        [dataName]="'detailsContract'"
        (clickSearch)="searchContract()"
      />
    </section>
    <section class="content-container">
      <h2 class="sub-heading w-full border-b">Details of COE</h2>
      <app-data-form
        [dataFields]="detailsCOE"
        [dataName]="'detailsCOE'"
        (updateFields_child)="updateFields($event)"
        (clickSearch)="searchData($event)"
      />
    </section>
    <div class="mt-4 flex w-fit gap-1">
      <button class="shorter-btn add-btn">
        <fa-icon [icon]="faPlus" class="mr-1" />Add
      </button>
      <button class="shorter-btn save-btn">
        <fa-icon [icon]="faEdit" class="mr-1" />Update
      </button>
      <button class="shorter-btn delete-btn">
        <fa-icon [icon]="faTrash" class="mr-1" />Delete
      </button>
      <button class="shorter-btn clear-btn">
        <fa-icon [icon]="faBroom" class="mr-1" />Clear
      </button>
    </div>
    <app-data-table
      *ngIf="tableEntriesGvcust.length > 0"
      class="mt-4 block"
      [tableHeaders]="tableHeadersGvcust"
      [tableEntries]="tableEntriesGvcust"
      [pagination]="false"
      (save)="addEntry($event, 'Gvcust')"
    />
    <app-data-table
      class="mt-4 block"
      *ngIf="tableEntriesGvcontract.length > 0"
      [tableHeaders]="tableHeadersGvcontract"
      [tableEntries]="tableEntriesGvcontract"
      [pagination]="false"
      (save)="addEntry($event, 'Contract')"
    />
  </div>
  <div
    [hidden]="!(selectedTab == 'all')"
    class="content-container__tabs"
  >
    <section class="content-container">
      <h2 class="sub-heading w-full border-b">
        Upload COE certificates
      </h2>
      <app-data-form
        [dataFields]="uploadCOECertificates"
        [dataName]="'uploadCOECertificates'"
        (updateFields_child)="updateFields($event)"
      />
      <label class="block px-8 text-sm font-bold">
        File Location
        <input
          type="file"
          name=""
          id=""
          class="ml-16"
          accept=".xlsx, .xls"
          multiple
        />
      </label>
      <div class="mt-4 flex w-fit gap-1">
        <button
          class="shorter-btn show-btn"
          [disabled]="!enableShow && !enableDate"
          (click)="showList()"
        >
          <fa-icon [icon]="faEye" class="mr-1" />Show list
        </button>
        <button class="shorter-btn clear-btn" (click)="clear()">
          <fa-icon [icon]="faBroom" class="mr-1" />Clear
        </button>
      </div>
    </section>
    <section class="content-container">
      <h2 class="sub-heading w-full border-b">Legend</h2>
      <div class="mt-4 flex gap-2 text-sm font-bold">
        <p
          *ngFor="let legend of filterLegends(legends)"
          class="rounded-full px-2"
          [ngClass]="legend.color"
        >
          {{ legend.label }}
        </p>
      </div>
    </section>
    <section class="content-container">
      <h2 class="sub-heading mb-4 w-full border-b">
        COE certificates
      </h2>
      <button
        class="shorter-btn darker-primary-btn misc-btn"
        disabled
      >
        <fa-icon [icon]="faUpload" class="mr-1" /> Allocate COE
        certificates to contracts
      </button>
      <app-data-table
        class="mt-4 block"
        *ngIf="tableEntriesGvcontract.length > 0"
        [tableHeaders]="tableEntriesCertificates"
        [tableEntries]="tableEntriesCertificates"
        [pagination]="false"
      />
    </section>
  </div>
</section>
